<template>
    <div class="content" v-show="liftNavGap > 500">
        <div class="item" v-for="nav in typeList" :key="nav.id" @click="goToDiv('item'+nav.id)">
            <span>{{ nav.cateName }}</span>
        </div>
    </div>
    <!-- 电梯导航 -->
</template>
<script name='liftnav'>
import { getCates } from '@/api/noticedetail.js'
export default {

    name: "TopTypeNav",
    props: {
        obj: Object,
    },
    data() {
        return {
            //第二级菜单分类
            typeList: [],
            //超过多大距离出现电梯导航
            liftNavGap:0,
        };
    },
    mounted(){
        this.getTypeList()
        window.addEventListener("scroll",this.scrollEvent); 
    },
    methods: {
        scrollEvent(){
            this.liftNavGap = document.documentElement.scrollTop;
        },
        // 商品分类
        async getTypeList() {
            var res = await getCates()
            //分类
            this.typeList = res.data[0].children;
        },
        goToDiv(div){
            const element = document.getElementById(div);
            //元素距离顶部实时距离
            const eleToTop = Math.abs((element.offsetTop) - 50);
            document.documentElement.scrollTop = eleToTop
        }
    },
}
</script>
<style scoped lang='less'>
/* scoped 使用得定义的样式只在本页面内生效  */
.content {
    position: fixed;
    top: 50%;
    left: 10px;
    transform: translate(0, -50%);
    width: 70px;
    height: auto;
    background-color: #fff;
    box-shadow: 0 0 10px 0 rgba(0, 0, 0, .2);
    border-radius: 5px;
    overflow: hidden;
    .item {
        box-sizing: border-box;
        width: 100%;
        height: auto;
        padding: 10px;
        text-align: center;
        border-bottom: 1px solid #efefef;
        cursor: pointer;

        &:hover {
            background-color: #F74747;
            span {
                color: #fff;
            }
        }

        span {
            font-size: 17px;
            color: #333;
            padding: 10px 0 0;
        }
    }
}
</style>
 


// WEBPACK FOOTER //
// src/components/base/LiftNav.vue